import { useState } from "react";
import {Table, Tbody, Td, Th, Thead, Tr,} from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import Pagination from "components/ui/pagination/Pagination";

export default function GiftCardsDataTable({ data }) {
  const { t } = useTranslation();
  /* --------------------------------------------- Start Pagination  -----------------------------------------------*/
  const recordsPerPage = 10;
  const [currentPageActive, setCurrentPageActive] = useState(1);
  const prePage = (currentPage, setCurrentPage) => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const nextPage = (currentPage, setCurrentPage, npage) => {
    if (currentPage < npage) {
      setCurrentPage(currentPage + 1);
    }
  };

  const calculateRecords = (data, currentPage, recordsPerPage) => {
    const firstIndex = (currentPage - 1) * recordsPerPage;
    const lastIndex = Math.min(currentPage * recordsPerPage, data?.length);
    return data?.slice(firstIndex, lastIndex);
  };

  // Calculate records for activeDiscounts
  const giftCardsReportData = calculateRecords(
    data,
    currentPageActive,
    recordsPerPage
  );
  /* --------------------------------------------- End Pagination  -----------------------------------------------*/
  return (
    <>
      <>
        <Table>
          <Thead>
            <Tr>
              <Th>{t("pages.reports.reports_tables.initial_balance")}</Th>
              <Th>{t("pages.reports.reports_tables.current_balance")}</Th>
              <Th>{t("pages.reports.reports_tables.number")}</Th>
              <Th>{t("pages.reports.reports_tables.created_at")}</Th>
              <Th>{t("pages.reports.reports_tables.last_used_at")}</Th>
            </Tr>
          </Thead>
          <Tbody>
            {giftCardsReportData?.map((item, index) => (
              <Tr key={index}>
                <Td>{item?.InitialBalance}</Td>
                <Td>{item?.CurrentBalance}</Td>
                <Td> {item?.Number} </Td>
                <Td> {item?.CreatedAt} </Td>
                <Td> {item?.LastUsedAt} </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
        <Pagination
          currentPage={currentPageActive}
          setCurrentPage={setCurrentPageActive}
          npage={Math.ceil(data?.length / recordsPerPage)}
          prePage={() => prePage(currentPageActive, setCurrentPageActive)}
          nextPage={() =>
            nextPage(
              currentPageActive,
              setCurrentPageActive,
              Math.ceil(data?.length / recordsPerPage)
            )
          }
        />
      </>
    </>
  );
};
